import Image from "next/image";
import Link from "next/link";
import { getImageUrl } from "@/utils/api-utils";

export interface ProgramCardProps {
  program: {
    id: number | string;
    slug?: string;
    href?: string;
    title: string;
    description: string;
    image: string;
    badge: string;
    duration?: string;
    category?: string;
  };
  basePath?: string;
}

export default function ProgramCard({ program, basePath = "/dai-hoc" }: ProgramCardProps) {
  const href = program.href || (program.slug ? `${basePath}/${program.slug}` : basePath);

  return (
    <Link href={href} className="program-card">
      <div className="program-card__image-wrapper">
        <Image
          src={getImageUrl(program.image)}
          alt={program.title}
          className="program-card__image"
          width={344}
          height={229}
          loading="lazy"
        />
        <span className="program-card__badge">
          <Image
            src="/assets/images/bookmark.png"
            alt=""
            className="program-card__badge-icon"
            width={17}
            height={17}
          />
          <span className="program-card__badge-text">{program.badge}</span>
        </span>
      </div>
      <div className="program-card__content">
        <h3 className="program-card__title">{program.title}</h3>
        <p className="program-card__description">{program.description}</p>
        
        {program.duration !== undefined && (
          <>
            <div className="program-card__divider"></div>
            <div className="program-card__footer">
              <div className="program-card__info">
                <Image
                  src="/assets/images/clock_primary.png"
                  alt=""
                  className="program-card__info-icon"
                  width={20}
                  height={20}
                />
                <span className="program-card__info-text">{program.duration}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </Link>
  );
}
